module.exports = __webpack_public_path__ + "img/2025-review-header.c52623a8.png";